export default "__VITE_ASSET__DLhs$q$N__"